var PNHeaderV2,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

require('../../../../../core/frontend/groupon_modules/ariaKeyNavigation');

require('../../../../../modules/gig_body/header/frontend/views/pn_primarynav');

module.exports = PNHeaderV2 = (function(superClass) {
  extend(PNHeaderV2, superClass);

  function PNHeaderV2($el) {
    this.$el = $el;
    this.$primaryNav = this.$el.find('.primary-nav');
    this.initialize();
  }

  PNHeaderV2.prototype.initialize = function() {
    if (!$('#ls-lite-header').length) {
      return new Groupon.LS.Header.PNPrimaryNav(this.$primaryNav);
    }
  };

  PNHeaderV2.prototype.bind = function() {
    var $userMenu, $userName;
    if (($userName = $('.user-name')).length) {
      $userMenu = $('#ls-my-stuff');
      if (Groupon.LS.hasTouch) {
        return $userName.off('tap').on('tap', function(e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          $userMenu.toggle();
          $userMenu.attr('aria-hidden', $userMenu.attr('aria-hidden') !== 'true');
          $('html').trigger('tap');
          if ($userMenu.is(':visible')) {
            return $('html').off('tap').one('tap', function(e) {
              if ($(e.target).closest('.user-name, .my-stuff').length === 0) {
                return $userMenu.hide().attr('aria-hidden', 'true');
              }
            });
          }
        });
      } else {
        return this.initMenuNavigation($userName, $userMenu, $userMenu.find('a'));
      }
    }
  };

  return PNHeaderV2;

})(Groupon.AriaMenuNavigation);

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL3NraW0vc2xzL21vZHVsZXMvZ2lnX2JvZHkvaGVhZGVyL2Zyb250ZW5kL3ZpZXdzL3BuX2hlYWRlcl92Mi5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvVXNlcnMvc2tpbS9zbHMvbW9kdWxlcy9naWdfYm9keS9oZWFkZXIvZnJvbnRlbmQvdmlld3MvcG5faGVhZGVyX3YyLmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBLFVBQUE7RUFBQTs7O0FBQUEsT0FBQSxDQUFRLGdFQUFSOztBQUNBLE9BQUEsQ0FBUSxxRUFBUjs7QUFFQSxNQUFNLENBQUMsT0FBUCxHQUF1Qjs7O0VBQ1Isb0JBQUMsR0FBRDtJQUFDLElBQUMsQ0FBQSxNQUFEO0lBQ1osSUFBQyxDQUFBLFdBQUQsR0FBZSxJQUFDLENBQUEsR0FBRyxDQUFDLElBQUwsQ0FBVSxjQUFWO0lBQ2YsSUFBQyxDQUFBLFVBQUQsQ0FBQTtFQUZXOzt1QkFJYixVQUFBLEdBQVksU0FBQTtJQUNWLElBQUEsQ0FBTyxDQUFBLENBQUUsaUJBQUYsQ0FBb0IsQ0FBQyxNQUE1QjthQUNNLElBQUEsT0FBTyxDQUFDLEVBQUUsQ0FBQyxNQUFNLENBQUMsWUFBbEIsQ0FBK0IsSUFBQyxDQUFBLFdBQWhDLEVBRE47O0VBRFU7O3VCQUlaLElBQUEsR0FBTSxTQUFBO0FBRUosUUFBQTtJQUFBLElBQUcsQ0FBQyxTQUFBLEdBQVksQ0FBQSxDQUFFLFlBQUYsQ0FBYixDQUE2QixDQUFDLE1BQWpDO01BQ0UsU0FBQSxHQUFZLENBQUEsQ0FBRSxjQUFGO01BR1osSUFBRyxPQUFPLENBQUMsRUFBRSxDQUFDLFFBQWQ7ZUFFRSxTQUFTLENBQUMsR0FBVixDQUFjLEtBQWQsQ0FBb0IsQ0FBQyxFQUFyQixDQUF3QixLQUF4QixFQUErQixTQUFDLENBQUQ7VUFDN0IsQ0FBQyxDQUFDLGNBQUYsQ0FBQTtVQUNBLENBQUMsQ0FBQyx3QkFBRixDQUFBO1VBQ0EsU0FBUyxDQUFDLE1BQVYsQ0FBQTtVQUNBLFNBQVMsQ0FBQyxJQUFWLENBQWdCLGFBQWhCLEVBQStCLFNBQVMsQ0FBQyxJQUFWLENBQWUsYUFBZixDQUFBLEtBQW1DLE1BQWxFO1VBRUEsQ0FBQSxDQUFFLE1BQUYsQ0FBUyxDQUFDLE9BQVYsQ0FBa0IsS0FBbEI7VUFDQSxJQUFHLFNBQVMsQ0FBQyxFQUFWLENBQWEsVUFBYixDQUFIO21CQUVFLENBQUEsQ0FBRSxNQUFGLENBQVMsQ0FBQyxHQUFWLENBQWMsS0FBZCxDQUFvQixDQUFDLEdBQXJCLENBQXlCLEtBQXpCLEVBQWdDLFNBQUMsQ0FBRDtjQUM5QixJQUFHLENBQUEsQ0FBRSxDQUFDLENBQUMsTUFBSixDQUFXLENBQUMsT0FBWixDQUFvQix1QkFBcEIsQ0FBNEMsQ0FBQyxNQUE3QyxLQUF1RCxDQUExRDt1QkFDRSxTQUFTLENBQUMsSUFBVixDQUFBLENBQWdCLENBQUMsSUFBakIsQ0FBc0IsYUFBdEIsRUFBcUMsTUFBckMsRUFERjs7WUFEOEIsQ0FBaEMsRUFGRjs7UUFQNkIsQ0FBL0IsRUFGRjtPQUFBLE1BQUE7ZUFlRSxJQUFDLENBQUEsa0JBQUQsQ0FBb0IsU0FBcEIsRUFBK0IsU0FBL0IsRUFBMEMsU0FBUyxDQUFDLElBQVYsQ0FBZSxHQUFmLENBQTFDLEVBZkY7T0FKRjs7RUFGSTs7OztHQVRrQyxPQUFPLENBQUMifQ==
